import { Home } from 'lucide-react'

import { cn } from '@/lib/utils'

interface ApartmentThumbnailProps {
  src: string | null
  alt: string
  className?: string
}

export function ApartmentThumbnail({
  src,
  alt,
  className
}: ApartmentThumbnailProps) {
  if (!src) {
    return (
      <div
        className={cn(
          'flex aspect-[4/3] w-full items-center justify-center rounded-lg bg-muted',
          className
        )}
      >
        <Home className="h-10 w-10 text-muted-foreground/50" />
      </div>
    )
  }

  return (
    <div
      className={cn(
        'relative aspect-[4/3] w-full overflow-hidden rounded-lg bg-muted',
        className
      )}
    >
      <img
        src={src}
        alt={alt}
        className="h-full w-full object-cover"
        loading="lazy"
        decoding="async"
      />
    </div>
  )
}
